const AlinaStorage = {
    Comment: {
        expanded: []
    }
};
export default AlinaStorage;
